import { RouterClient } from "../../../../clients/routerClient";
import { Logger } from "../../../../clients/logger";
import { WindowIdentifier } from "../types";

class WrapManagerSingleton {
	wraps: object;

	constructor() {
		this.wraps = {};
	}

	add(params: { windowIdentifier: WindowIdentifier; windowDescriptor: any }) {
		const { windowIdentifier, windowDescriptor } = params;
		this.wraps[windowIdentifier.windowName] = {
			identifier: windowIdentifier,
			descriptor: windowDescriptor,
			owners: [],
		};
		Logger.system.debug("WRAP. adding window", windowIdentifier.windowName);
		RouterClient.publish(`Finsemble.${windowIdentifier.windowName}.wrapReady`, {
			name: windowIdentifier.windowName,
			state: "open",
		});
	}

	get(params: { windowName: string; requester: string }, cb: Function = Function.prototype) {
		const { windowName, requester } = params;
		const wrap = this.wraps[windowName];
		let err: string | null = null;
		Logger.system.debug("WRAP. wrap requested from", requester, "for", windowName);
		if (wrap) {
			if (!wrap.owners.includes(requester)) wrap.owners.push(requester);
		} else {
			err = `No wrap found for ${windowName}`;
			Logger.system.error("WRAPMANAGER.get Error", err, requester, "for", windowName);
		}
		cb(err, wrap);
		return Promise.resolve({ err, data: wrap });
	}

	remove(windowName: string) {
		delete this.wraps[windowName];
	}

	setUuid(name: string, uuid: string) {
		if (this.wraps[name]) {
			this.wraps[name].identifier.uuid = uuid;
			this.wraps[name].descriptor.uuid = uuid;
		} else {
			Logger.system.error("WrapManager.setUuid. Wrap not found for", name);
		}
	}
}

export const WrapManager: WrapManagerSingleton = new WrapManagerSingleton();
